import { render, staticRenderFns } from "./Uom.vue?vue&type=template&id=459029be"
import script from "./Uom.vue?vue&type=script&lang=js"
export * from "./Uom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports